<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        Policy
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Policy</a>
        </li>
      </ul>
    </div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto mb7">
              Policy
              <br>
              <span class="font_12">Setting up Check methods.</span>
            </div>
            <div class="mb7">
              <small class="float-right">{{model.created_at | datetime}}</small>
            </div>
          </div>
          <hr>
          <b-row class="mb-3" v-if="model && model.policy">
            <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="ph_policy" v-b-tooltip.hover>
                Policy Description
              </label>
            </b-col>
            <b-col class="col-xl-4 col-md-12  d-flex align-self-center">
              <b-form-input type="text" id="ph_descrip" v-model="model.description" :plaintext="lock"></b-form-input>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="4">
              <b-form-group>
                <label for="ph_depth" v-b-tooltip.hover title="Enter whether to check by moving (path) the link from the first page to the next. Can be specified within the range 1-100." style="border-bottom: 2px solid;">
                  Maximum path depth
                </label>
                <b-form-input type="number" id="ph_depth" :min="1" :max="100" v-model="model.policy.depth" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_links" v-b-tooltip.hover style="border-bottom: 2px solid;" title="Enter the maximum sublink to navigate within a page. Ignore any excess links. Normally, if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way. You can specify it within the range of 1-1,000.">Sub Page Link</label>
                <b-form-input type="number" id="ph_links" :min="1" :max="1000" v-model="model.policy.links" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_limit" v-b-tooltip.hover style="border-bottom: 2px solid;" title="`Total number of pages to check on the inspection site. End the check when the entered number is reached. can be specified within the range of 1 to license limit.`">Maximum Navigation Page</label>
                <b-form-input type="number" id="ph_limit" :min="10" :max="limit" v-model="model.policy.limit" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col md="4">
              <b-form-group>
                <label for="ph_timeout" v-b-tooltip.hover style="border-bottom: 2px solid;" title="Time to wait for page loading. can be specified within the range of 1-30.">TimeOut(Second)</label>
                <b-form-input type="number" id="ph_timeout" :min="1" :max="30" v-model="model.policy.timeout" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <label for="ph_delay" v-b-tooltip.hover style="border-bottom: 2px solid;" title="Time to wait before moving to a new page. can be specified within the range of 1 to 10,000.">Check Speed(Millisecond)</label>
                <b-form-input type="number" id="ph_delay" :min="0" :max="10000" v-model="model.policy.delay" :plaintext="lock"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="lock">
            <template v-if="model.is_del">
              <!-- <b-button size="sm" variant="success" @click="revive"> 되살리기 </b-button> -->
              <span class="text-danger">was deleted policy.</span>
            </template>
            <template v-else>
              <b-button size="sm" variant="warning" @click="edit"> Edit </b-button>
              <b-button size="sm" variant="danger" @click="remove"> Remove </b-button>
            </template>
          </template>
          <template v-else>
            <b-button size="sm" class="btn btn-add" @click="save"> Saved </b-button>
            <b-button size="sm" variant="secondary" @click="cancel"> Cancel </b-button>
          </template>
          <b-button size="sm" class="float-right" variant="primary" @click="list"> List </b-button>
        </b-card>
        <!-- <siteList v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList> -->
      </b-col>
      <!-- <siteList class="col-md" v-if="model.id" :policy_id="model.id" :enable_new="false"></siteList> -->
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>